import L from 'leaflet';

const TILE_RETRY_DELAY_MS = 1000;
const TILE_MAX_RETRIES = 3;

function retryFailedTile(event) {
    const tile = event.tile;
    tile.retries = tile.retries || 0;
    if (tile.retries < TILE_MAX_RETRIES) {
        setTimeout(() => {
            // eslint-disable-next-line no-self-assign
            tile.src = tile.src;
            tile.retries += 1;
        }, TILE_RETRY_DELAY_MS * tile.retries);
    } else {
        // eslint-disable-next-line no-console
        console.log(`tile ${tile.src} failed ${tile.retries} times, not retrying.`);
    }
}

function withRetry(layer) {
    layer.on('tileerror', retryFailedTile);
    return layer;
}

export function createBaseLayer(url, attribution) {
    return withRetry(L.tileLayer(url, {
        attribution,
        maxNativeZoom: 20
    }));
}

export function createOverlays() {
    const luchtfoto = L.layerGroup([
        withRetry(L.tileLayer(
            'https://geo.api.vlaanderen.be/OMWRGBMRVL/wmts?service=WMTS&request=GetTile&version=1.0.0&layer=omwrgbmrvl&Format=image/png&tilematrixset=GoogleMapsVL&TileMatrix={z}&TileRow={y}&TileCol={x}',
            {
                attribution: 'Agentschap Digitaal Vlaanderen',
                tileSize: 128,
                zoomOffset: 1
            })),
        withRetry(L.tileLayer.wms('https://geo.api.vlaanderen.be/GRB/wms', {
            attribution: 'Agentschap Digitaal Vlaanderen',
            layers: 'GRB_SNM',
            styles: 'GRB_SNM',
            format: 'image/png',
            transparent: true
        }))
    ]);

    const anbGebieden = withRetry(L.tileLayer.wms('https://www.mercator.vlaanderen.be/raadpleegdienstenmercatorpubliek/wms', {
        attribution: 'Vlaamse Overheid - Beleidsdomein Omgeving - MercatorNet',
        layers: 'am:am_patdat',
        styles: 'am_patdat_std',
        format: 'image/png',
        transparent: true,
        opacity: 0.7,
        CQL_FILTER: "rechtenanb <> 'Protocol landsverdediging' AND rechtenanb <> 'Technisch beheer conform bosdecreet'"
    }));

    const gemeenteGrenzen = withRetry(L.tileLayer.wms('https://geo.api.vlaanderen.be/Administratieve_Eenheden/wms', {
        attribution: 'Agentschap Digitaal Vlaanderen',
        layers: 'RefgemGrens',
        styles: 'default',
        format: 'image/png',
        transparent: true
    }));

    return [
        { name: 'Luchtfoto', layer: luchtfoto, checked: false },
        { name: 'ANB Gebieden', layer: anbGebieden, checked: true },
        { name: 'Gemeente grenzen', layer: gemeenteGrenzen, checked: false }
    ];
}
